export default __webpack_public_path__ + "static/media/star-icon.5ccffbb8.svg";